import axios from "axios";

export default {
    bind(el, binding) {
        axios.get(binding.value).then((response) => {
            el.innerHTML = response.data.data.address;
        });
    },
}
